;(function() {
  'use strict'

  Controller.$inject = ["projectService"];
  angular.module('app.project').component('newSurveyDialog', {
    controller: Controller,
    templateUrl: 'new-survey-dialog.html',
    bindings: {
      onSelect: '&',
      onClose: '&',
    },
  })

  var ROUTES = [
    {
      value: 'ai',
      label: 'Build with AI',
      sub: 'Describe your goal or upload a brief',
      icon: 'chat',
      ai: true,
    },
    {
      value: 'upload',
      label: 'Upload a survey',
      sub: 'Import from a Word or PDF file, or another tool',
      icon: 'publish',
      ai: true,
    },
    {
      value: 'template',
      label: 'Create from template',
      sub: 'Start from a proven survey in Kits',
      icon: 'kit',
    },
    {
      value: 'copy',
      label: 'Copy an existing survey',
      sub: 'Pick questions from a survey you already have',
      icon: 'copy',
    },
    {
      value: 'scratch',
      label: 'Start from scratch',
      sub: 'Build a blank survey question by question',
      icon: 'add',
    },
  ]

  /* @ngInject */
  function Controller(projectService) {
    var ctrl = this

    ctrl.$onInit = onInit

    function onInit() {
      var hasSurveys = _.sumBy(projectService.projects, 'surveyCount') > 0
      ctrl.routes = hasSurveys ? ROUTES : _.reject(ROUTES, { value: 'copy' })
    }
  }
})()
